import { render, staticRenderFns } from "./PointOfSale.vue?vue&type=template&id=f3262c6e&"
import script from "./PointOfSale.vue?vue&type=script&lang=js&"
export * from "./PointOfSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports